import React from 'react';
import { IonCheckbox } from '@ionic/react';
import { pxToRem } from '@/modules/config';
import { useExpandToAnchor } from './WelcomeSheet';
import {
  HOME_INSTALL_ANCHOR,
  HOME_INSTALL_WHY_ANCHOR,
} from './HomeInstallDetailBlocks';
import '@/components/Interstitial.css';

interface HomeInstallNudgeBlockProps {
  dismissed: boolean;
  onDismissedChange: (checked: boolean) => void;
}

/**
 * The above-the-fold Home-Screen install nudge: the pitch, its two links into
 * the detail zone, and the "Got it!" checkbox that suppresses it for good.
 * Pairs with `HomeInstallDetailBlocks`, which holds the anchors it links to.
 */
const HomeInstallNudgeBlock: React.FC<HomeInstallNudgeBlockProps> = ({
  dismissed,
  onDismissedChange,
}) => {
  const expandToAnchor = useExpandToAnchor();

  return (
    <>
      <p className="interstitial__message">
        To make the most of Snowball, follow the{' '}
        <button
          className="interstitial__link"
          onClick={() => expandToAnchor(HOME_INSTALL_ANCHOR)}
        >
          instructions below
        </button>{' '}
        to add it to your Home Screen{' '}
        <span style={{ whiteSpace: 'nowrap' }}>
          (
          <button
            className="interstitial__link"
            onClick={() => expandToAnchor(HOME_INSTALL_WHY_ANCHOR)}
          >
            convince me
          </button>
          )
        </span>
        .
      </p>

      <div className="interstitial__checkbox-row">
        <IonCheckbox
          checked={dismissed}
          onIonChange={e => onDismissedChange(e.detail.checked)}
        />
        <span
          style={{ fontSize: pxToRem(14), color: 'var(--ion-color-medium)' }}
        >
          Got it!
        </span>
      </div>
    </>
  );
};

export default HomeInstallNudgeBlock;
